import { Alert, Button, Container, Spinner } from 'react-bootstrap';
import type { TFunction } from 'i18next';

type RsBoardRouteStatesProps =
  | { kind: 'invalid'; t: TFunction }
  | { kind: 'loading' }
  | {
      kind: 'error';
      t: TFunction;
      notFound: boolean;
      showBack: boolean;
      onBack: () => void;
    };

/** 共有URL不正・読込中・読込失敗の早期 return UI */
export default function RsBoardRouteStates(props: RsBoardRouteStatesProps) {
  if (props.kind === 'invalid') {
    return (
      <Container className="py-4">
        <Alert variant="danger">
          {props.t('reservation.board.invalidId', { defaultValue: '予約表が見つかりません。' })}
        </Alert>
      </Container>
    );
  }

  if (props.kind === 'loading') {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status" />
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <Alert variant="danger">
        {props.notFound
          ? props.t('reservation.board.shareNotFound', {
              defaultValue:
                'この共有URLの予約表は見つかりません。URLが古い、停止された、または別環境のリンクの可能性があります。',
            })
          : props.t('reservation.board.loadFailed', {
              defaultValue: '予約表の読み込みに失敗しました。',
            })}
      </Alert>
      {props.showBack ? (
        <Button variant="outline-secondary" onClick={props.onBack}>
          {props.t('common.back', { defaultValue: '戻る' })}
        </Button>
      ) : null}
    </Container>
  );
}
